<ng-container *ngIf="ablaufmanagementFonds$ | async as ablaufmanagementFonds">
  <ng-container *ngIf="!!ablaufmanagementFonds.data.length">
    <lv-anlauf-ablauf-management-table class="lv-uebersicht-portfolio-table"
                                       [dataSource]="ablaufmanagementFonds"></lv-anlauf-ablauf-management-table>
  </ng-container>
</ng-container>
